import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ONBOARDING_REPO_FREE, ONBOARDING_REPO_SELECT } from "@/util";
import { integrationsStore, onboardingApiStore } from "@/hooks";
import { GitHubProjectInput } from "@/components/integrations";
import { Typography, TextButton, FlexBox } from "@/components/common";
import CalloutSubStep from "./CalloutSubStep.vue";

/**
 * Handles continuing to the next step.
 */

/**
 * Configures GitHub to import from a repository during onboarding.
 */
const __default__ = {
  name: "SelectRepoStep",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

function handleContinue() {
  onboardingApiStore.handleLoadNextStep("code");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Typography), {
      el: "p",
      value: _unref(ONBOARDING_REPO_SELECT)
    }, null, 8, ["value"]),
    _createVNode(_unref(GitHubProjectInput), { minimal: "" }),
    (!!_unref(integrationsStore).gitHubProject)
      ? (_openBlock(), _createBlock(_unref(FlexBox), {
          key: 0,
          t: "4",
          justify: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TextButton), {
              outlined: "",
              label: "Continue",
              onClick: handleContinue
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(CalloutSubStep, {
          key: 1,
          icon: "share",
          message: _unref(ONBOARDING_REPO_FREE)
        }, null, 8, ["message"]))
  ], 64))
}
}

})